<div class="content-body">
  <app-breadcrumb [breadcrumb]="breadcrumbList"></app-breadcrumb>
  <div class="container-fluid">
    <!-- Comments & History Tabs -->
    <div class="card mb-3">
      <div class="card-header d-flex justify-content-between align-items-center">
        <ul class="nav nav-tabs card-header-tabs">
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'comments'" (click)="setActiveTab('comments')" role="button">
              Follow Up History
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'history'" (click)="setActiveTab('history')" role="button">
              Stage/Status History
            </a>
          </li>
        </ul>
        <button
          *ngIf="canAddComments && activeTab === 'comments'"
          class="btn btn-primary btn-sm"
          (click)="openCommentDrawer()"
          [disabled]="loadingService.isLoading()"
        >
          <i class="bi bi-plus-circle me-1"></i> Add Comment
        </button>
      </div>
      <div class="card-body">
        <!-- Comments Tab -->
        <div *ngIf="activeTab === 'comments'">
          <div class="table-responsive" *ngIf="comments.length > 0">
            <table class="table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Added By</th>
                  <th>Comment</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let comment of comments">
                  <td>{{ comment.created_at | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ comment.created_by }}</td>
                  <td [innerHTML]="comment.comment"></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="text-center py-4" *ngIf="comments.length === 0">
            <p>No comments available</p>
          </div>
        </div>

        <!-- History Tab -->
        <div *ngIf="activeTab === 'history'">
          <div class="table-responsive" *ngIf="history.length > 0">
            <table class="table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Field</th>
                  <th>Previous Value</th>
                  <th>New Value</th>
                  <th>Changed By</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of history">
                  <td>{{ item.changed_at | date: 'dd-MM-yyyy HH:mm' }}</td>
                  <td class="text-capitalize">{{ item.field }}</td>
                  <td>{{ item.previous_value || '-' }}</td>
                  <td>{{ item.new_value }}</td>
                  <td>{{ item.changed_by || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="text-center py-4" *ngIf="history.length === 0">
            <p>No stage/status history available</p>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h4 class="card-title">Lead Details</h4>
        <button
          class="btn btn-secondary btn-sm"
          (click)="backToLeads()"
        >
          <i class="bi bi-arrow-left me-1"></i> Back to Leads
        </button>
      </div>
      <div class="card-body" *ngIf="lead">
        <div class="row">
          <div class="col-md-4 mb-3">
            <label class="fw-bold">Name:</label>
            <p>{{ lead.name }}</p>
          </div>
          <div class="col-md-4 mb-3">
            <label class="fw-bold">Email:</label>
            <p>{{ lead.email }}</p>
          </div>
          <div class="col-md-4 mb-3">
            <label class="fw-bold">Phone:</label>
            <p>{{ lead.phone }}</p>
          </div>
          <div class="col-md-4 mb-3">
            <label class="fw-bold">Stage:</label>
            <p>
              <span
                class="badge"
                [ngClass]="{
                  'bg-secondary': lead.stage === 'New',
                  'bg-info': lead.stage === 'Reached Out' || lead.stage === 'Introduction Done',
                  'bg-primary': lead.stage === 'Inspection Done',
                  'bg-warning text-dark': lead.stage === 'Draft Agreement Sent' || lead.stage === 'Final Agreement Sent',
                  'bg-success': lead.stage === 'Token/Fee Paid'
                }"
              >
                {{ lead.stage }}
              </span>
            </p>
          </div>
          <div class="col-md-4 mb-3">
            <label class="fw-bold">Status:</label>
            <p>
              <span
                class="badge"
                [ngClass]="{
                  'bg-danger': lead.status === 'Hot',
                  'bg-warning text-dark': lead.status === 'Warm',
                  'bg-info': lead.status === 'Cold',
                  'bg-secondary': lead.status === 'Reject',
                  'bg-success': lead.status === 'Converted'
                }"
              >
                {{ lead.status }}
              </span>
            </p>
          </div>
          <div class="col-md-4 mb-3">
            <label class="fw-bold">Service:</label>
            <p>{{ lead.service || '-' }}</p>
          </div>
          <div class="col-md-4 mb-3">
            <label class="fw-bold">Source:</label>
            <p>
              <span *ngIf="lead.source" class="badge" [ngClass]="sourceClass(lead)">{{ lead.source }}</span>
              <span *ngIf="!lead.source">-</span>
              <small *ngIf="lead.source_website" class="d-block fw-semibold mt-1" [ngClass]="websiteClass(lead.source_website)">
                {{ lead.source_website }}
              </small>
            </p>
          </div>
          <div class="col-md-4 mb-3">
            <label class="fw-bold">Property Type:</label>
            <p>{{ lead.property_type }}</p>
          </div>
          <div class="col-md-4 mb-3">
            <label class="fw-bold">Locality:</label>
            <p>{{ lead.locality }}</p>
          </div>
          <div class="col-md-4 mb-3">
            <label class="fw-bold">City:</label>
            <p>{{ lead.city }}</p>
          </div>
          <div class="col-md-4 mb-3">
            <label class="fw-bold">State:</label>
            <p>{{ lead.state }}</p>
          </div>
          <div class="col-md-4 mb-3">
            <label class="fw-bold">Follow Up On:</label>
            <p>{{ lead.follow_up_date ? (lead.follow_up_date | date: 'dd-MM-yyyy') : '-' }}</p>
          </div>
          <div class="col-md-4 mb-3" *ngIf="lead.customer_location">
            <label class="fw-bold">Customer Location:</label>
            <p>{{ lead.customer_location }}</p>
          </div>
          <div class="col-md-4 mb-3" *ngIf="lead.customer_city">
            <label class="fw-bold">Customer City:</label>
            <p>{{ lead.customer_city }}</p>
          </div>
          <div class="col-md-4 mb-3" *ngIf="lead.customer_state">
            <label class="fw-bold">Customer State:</label>
            <p>{{ lead.customer_state }}</p>
          </div>
          <div class="col-md-4 mb-3" *ngIf="lead.follow_up_date">
            <label class="fw-bold">Follow Up Date:</label>
            <p>{{ lead.follow_up_date | date: 'dd-MM-yyyy' }}</p>
          </div>
          <div class="col-md-4 mb-3">
            <label class="fw-bold">Created At:</label>
            <p>{{ lead.created_at | date: 'dd-MM-yyyy' }}</p>
          </div>
          <div class="col-md-4 mb-3" *ngIf="lead.created_by">
            <label class="fw-bold">Created By:</label>
            <p>{{ lead.created_by }}</p>
          </div>
          <div class="col-md-4 mb-3" *ngIf="lead.maps_link">
            <label class="fw-bold">Google Maps:</label>
            <p>
              <a [href]="lead.maps_link" target="_blank" rel="noopener">Open in Maps</a>
            </p>
          </div>
          <div class="col-12 mb-3" *ngIf="lead.uploads && lead.uploads.length > 0">
            <label class="fw-bold">Attachments:</label>
            <ul class="list-group">
              <li class="list-group-item d-flex justify-content-between align-items-center"
                *ngFor="let file of lead.uploads">
                <a [href]="file.upload_key" target="_blank" rel="noopener" class="text-truncate">
                  {{ file.original_name || 'Attachment' }}
                </a>
                <span class="badge bg-light text-dark" *ngIf="file.created_at">
                  {{ file.created_at | date: 'dd-MM-yyyy' }}
                </span>
              </li>
            </ul>
          </div>
          <div class="col-12 mb-3">
            <label class="fw-bold">Notes:</label>
            <textarea
              class="form-control notes-textarea"
              [(ngModel)]="notesText"
              rows="4"
              placeholder="Enter notes..."
            ></textarea>
            <div class="mt-2" *ngIf="notesText !== lead.looking_for">
              <button
                class="btn btn-primary btn-sm"
                (click)="saveNotes()"
                [disabled]="loadingService.isLoading()"
              >
                <i class="fa fa-save me-1"></i> Save Notes
              </button>
              <span class="text-muted ms-2 small">Unsaved changes</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body text-center py-5" *ngIf="!lead && !loadingService.isLoading()">
        <p>No lead details available</p>
      </div>
    </div>

    <!-- Tasks linked to this lead -->
    <div class="mt-3" *ngIf="canViewTasks && leadId">
      <app-tasks-list [embedded]="true" relatedType="lead" [relatedId]="leadId" [linkName]="lead?.name ?? null"></app-tasks-list>
    </div>

  </div>
</div>

<!-- Comment Drawer -->
<div
  class="offcanvas offcanvas-end customeoff"
  tabindex="-1"
  id="commentDrawer"
  aria-labelledby="commentDrawerLabel"
>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="commentDrawerLabel">Add Comment</h5>
    <button
      type="button"
      class="btn-close"
      (click)="closeCommentDrawer()"
      aria-label="Close"
    ></button>
  </div>
  <div class="offcanvas-body">
    <form [formGroup]="commentForm" (ngSubmit)="saveComment()">
      <div class="mb-3">
        <label class="form-label">Comment <span class="text-danger">*</span></label>
        <ckeditor
          [editor]="Editor"
          formControlName="comment"
          [config]="{ toolbar: ['bold', 'italic', 'link', 'bulletedList', 'numberedList'] }"
        ></ckeditor>
        <div
          class="text-danger mt-1"
          *ngIf="commentForm.get('comment')?.invalid && commentForm.get('comment')?.touched"
        >
          Comment is required
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-secondary me-2"
          (click)="closeCommentDrawer()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="commentForm.invalid || loadingService.isLoading()"
        >
          Save Comment
        </button>
      </div>
    </form>
  </div>
</div>
